import { Navbar } from "./components/landing/Navbar";
import { Hero } from "./components/landing/Hero";
import { Capabilities } from "./components/landing/Capabilities";
import { FeaturedTactical } from "./components/landing/FeaturedTactical";
import { Process } from "./components/landing/Process";
import { About } from "./components/landing/About";
import { CompanyData } from "./components/landing/CompanyData";
import { Faq } from "./components/landing/Faq";
import { Contact } from "./components/landing/Contact";
import { Footer } from "./components/landing/Footer";
import { Toaster } from "sonner";

function App() {
  return (
    <div className="App min-h-screen bg-[#0A0A0A] antialiased">
      <Toaster theme="dark" position="top-center" richColors />
      <Navbar />
      <main>
        <Hero />
        <Capabilities />
        <FeaturedTactical />
        <Process />
        <About />
        <CompanyData />
        <Faq />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
